<template>
  <div v-if="visible" class="pop_mask">
    <div class="pop_content">
      <div class="pop_info">
        <div class="pop_logo"></div>
        <ul class="input_list">
          <li class="input1">
            <input type="text" v-model="phone" placeholder="请输入手机号" />
            <span class="input_tips">{{ phoneTips }}</span>
          </li>
          <li class="input2">
            <input type="text" v-model="code" placeholder="输入短信验证码" />
            <a href="javascript:;" class="btn_code" @click="getCodeClick">
              <span v-if="codeTime === 0">获取验证码</span>
              <span v-else>{{ codeTime }}s</span>
            </a>
            <span class="input_tips">{{ codeTips }}</span>
          </li>
        </ul>
        <div class="agree_con">
          <div class="checkbox" @click="checked = !checked">
            <i class="checkbox_icon" v-if="checked"></i>
          </div>
          <div class="agree_box">
            阅读并同意
            <a
              href="https://rule.sarosgame.com/sarosis/20250609/l6/tos.html"
              target="_blank"
              >《用户协议》</a
            >
            <a
              href="https://rule.sarosgame.com/sarosis/20250609/l6/pp.html"
              target="_blank"
              >《隐私政策》</a
            >
          </div>
        </div>
        <p class="zc_tips"></p>
        <a href="javascript:;" class="btn_submit" @click="submit">确认预约</a>
      </div>
      <a href="javascript:;" @click="close" class="pop_close db">关闭</a>
    </div>
    <div class="loading_box" v-if="loadingState">
      <img src="/img/pc/loading.gif" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { defineProps, defineEmits } from "vue";
import { getCode, makeReservation } from "@/api";
import { toast } from "vue3-toastify";
import {
  homeOnOfficialMediaAppointCompleteReporting,
  homeOnOfficialMediaAppointSuccessReporting,
} from "@/utils/reporting";

const props = defineProps({
  visible: Boolean,
});
const emit = defineEmits(["close"]);
function close() {
  emit("close");
}

const loadingState = ref(false);

function showToast(msg) {
  toast.info(msg);
}

const phone = ref("");
const code = ref("");
const phoneTips = ref("");
const codeTips = ref("");
const checked = ref(false);
const codeTime = ref(0);
let timer = null;

// ✅ 校验手机号格式
function isPhoneValid(number) {
  return /^1[3-9]\d{9}$/.test(number);
}

// ✅ 提取公共手机号校验函数
function validatePhone() {
  if (!phone.value) {
    phoneTips.value = "请输入手机号";
    return false;
  }
  if (!isPhoneValid(phone.value)) {
    phoneTips.value = "手机号格式错误";
    return false;
  }
  phoneTips.value = "";
  return true;
}

// ✅ 提取公共验证码校验函数
function validateCode() {
  if (!code.value) {
    codeTips.value = "请输入验证码";
    return false;
  }
  codeTips.value = "";
  return true;
}

// ✅ 监听输入时动态校验
watch(phone, () => {
  validatePhone();
});
watch(code, () => {
  validateCode();
});

// 获取验证码按钮点击
async function getCodeClick() {
  if (codeTime.value > 0) return;
  if (!validatePhone()) return;

  try {
    await getCode(phone.value);
    loadingState.value = true;
    showToast("验证码已发送");

    codeTime.value = 59;
    timer = setInterval(() => {
      codeTime.value--;
      if (codeTime.value <= 0) {
        clearInterval(timer);
        codeTime.value = 0;
      }
    }, 1000);
    loadingState.value = false;
  } catch (error) {
    showToast("获取验证码失败");
    console.log("获取验证码失败", error);
    loadingState.value = false;
  }
}

// 提交注册/登录
async function submit() {
  homeOnOfficialMediaAppointCompleteReporting();
  let hasError = false;

  if (!validatePhone()) hasError = true;
  if (!validateCode()) hasError = true;

  if (!checked.value) {
    document.querySelector(".agree_con").classList.remove("nochecked");
    setTimeout(() => {
      document.querySelector(".agree_con").classList.add("nochecked");
    }, 100);
    hasError = true;
  } else {
    document.querySelector(".agree_con").classList.remove("nochecked");
  }

  if (hasError) return;

  try {
    loadingState.value = true;
    const res = await makeReservation(code.value, phone.value);

    if (res.code) {
      if (res.code === 40000 || res.code === 42203) {
        showToast("验证码错误或已过期");
      } else if (res.code === 42201) {
        showToast("当前手机号已经提交过，请勿重复提交");
      } else {
        showToast("提交失败，请稍后再试");
      }
      console.log(res);
    } else {
      showToast("提交成功");
      code.value = "";
      phone.value = "";
      checked.value = false;
      emit("close");
      homeOnOfficialMediaAppointSuccessReporting();
    }
    loadingState.value = false;
  } catch (error) {
    showToast(error);
    console.log(error);
    loadingState.value = false;
  }
}
</script>

<style lang="scss" scoped>
.pop_mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.pc_wrap {
  .loading_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: calc(80 / 2560 * 100vw);
      height: calc(80 / 2560 * 100vw);
    }
  }
  .pop_content {
    background: url(/img/pc/pop.png) no-repeat;
    background-size: 100% 100%;
    width: calc(887 / 2560 * 100vw);
    height: calc(589 / 2560 * 100vw);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: showPop 0.5s ease both;
  }
  .pop_close {
    position: absolute;
    right: calc(-25 / 2560 * 100vw);
    top: 0;
    background: url(/img/pc/close.png) no-repeat;
    background-size: 100% 100%;
    width: calc(52 / 2560 * 100vw);
    height: calc(49 / 2560 * 100vw);
    transition: all 0.3s;
  }
  .pop_close:hover {
    transform: scale(1.1);
  }
  .pop_close:active {
    transform: scale(1);
  }
  .pop_logo {
    background: url(/img/pc/pop_logo.png) no-repeat;
    background-size: 100% 100%;
    width: calc(245 / 2560 * 100vw);
    height: calc(83 / 2560 * 100vw);
    margin: 0 auto calc(10 / 2560 * 100vw);
  }
  .input_list {
    padding: calc(20 / 2560 * 100vw) 0;
    width: calc(685 / 2560 * 100vw);
    margin: 0 auto;
    li {
      width: 100%;
      height: calc(70 / 2560 * 100vw);
      box-sizing: border-box;
      font-family: "font1";
      line-height: calc(70 / 2560 * 100vw);
      margin-bottom: calc(30 / 2560 * 100vw);
      position: relative;
      input {
        font-family: "font1";
        float: left;
        padding: 0 calc(25 / 2560 * 100vw);
        box-sizing: border-box;
        border: none;
        outline: none;
        background: none;
        font-size: calc(24 / 2560 * 100vw);
        color: #585858;
        height: calc(70 / 2560 * 100vw);
        line-height: calc(70 / 2560 * 100vw);
      }
      .input_tips {
        font-size: calc(24 / 2560 * 100vw);
        line-height: calc(30 / 2560 * 100vw);
        color: #d7c6a1;
        position: absolute;
        left: 0;
        top: 100%;
      }
    }
    .input1 {
      background: url(/img/pc/input1.png) no-repeat;
      background-size: 100% 100%;
      padding-left: calc(90 / 2560 * 100vw);
      input {
        width: 100%;
      }
    }
    .input2 {
      background: url(/img/pc/input2.png) no-repeat;
      background-size: 100% 100%;
      input {
        width: calc(514 / 2560 * 100vw);
      }
      .btn_code {
        float: right;
        width: calc(168 / 2560 * 100vw);
        text-align: center;
        color: #d7c6a1;
        font-size: calc(24 / 2560 * 100vw);
      }
    }
  }
  .agree_con {
    display: flex;
    justify-content: center;
    align-items: stretch;
    line-height: calc(28 / 2560 * 100vw);
    margin-bottom: calc(5 / 2560 * 100vw);
    text-align: center;
    .checkbox {
      width: calc(20 / 2560 * 100vw);
      height: calc(20 / 2560 * 100vw);
      border: 1px solid #b3b3b3;
      box-sizing: border-box;
      position: relative;
      margin-right: calc(12 / 2560 * 100vw);
      cursor: pointer;
      .checkbox_icon {
        background: url(/img/pc/cur.png) no-repeat;
        background-size: 100% 100%;
        width: calc(22 / 2560 * 100vw);
        height: calc(20 / 2560 * 100vw);
        position: absolute;
        left: 0;
        bottom: calc(1 / 2560 * 100vw);
      }
    }
    .agree_box {
      font-size: calc(20 / 2560 * 100vw);
      color: #a0a0a0;
      display: flex;
      justify-content: center;
      align-items: stretch;
      line-height: calc(28 / 2560 * 100vw);
      a {
        color: #d7c6a1;
      }
    }
  }
  .zc_tips {
    font-size: calc(20 / 2560 * 100vw);
    color: #a0a0a0;
    line-height: calc(28 / 2560 * 100vw);
    text-align: center;
    padding-bottom: calc(15 / 2560 * 100vw);
  }
  .btn_submit {
    background: url(/img/pc/pop_btn.png) no-repeat;
    background-size: 100% 100%;
    width: calc(425 / 2560 * 100vw);
    height: calc(70 / 2560 * 100vw);
    box-sizing: border-box;
    padding: 0 calc(45 / 2560 * 100vw);
    display: block;
    margin: 0 auto;
    line-height: calc(70 / 2560 * 100vw);
    text-align: center;
    color: #d7c6a1;
    transition: all 0.2s;
    font-size: calc(28 / 2560 * 100vw);
  }
  .btn_submit:hover {
    filter: brightness(1.1);
  }
  .btn_submit:active {
    color: #b6a47c;
  }

  @keyframes showPop {
    0% {
      transform: translateY(calc(-10 / 2560 * 100vw));
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
.mobile_wrap {
  .loading_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: calc(80 / 750 * 100vw);
      height: calc(80 / 750 * 100vw);
    }
  }
  .pop_content {
    background: url(/img/m/pop.png) no-repeat;
    background-size: 100% 100%;
    width: calc(678 / 750 * 100vw);
    height: calc(450 / 750 * 100vw);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: showPop 0.5s ease both;
  }
  .pop_close {
    position: absolute;
    right: calc(-20 / 750 * 100vw);
    top: 0;
    background: url(/img/pc/close.png) no-repeat;
    background-size: 100% 100%;
    width: calc(42 / 750 * 100vw);
    height: calc(41 / 750 * 100vw);
    transition: all 0.3s;
  }
  .pop_close:hover {
    transform: scale(1.1);
  }
  .pop_close:active {
    transform: scale(1);
  }
  .pop_logo {
    background: url(/img/pc/pop_logo.png) no-repeat;
    background-size: 100% 100%;
    width: calc(188 / 750 * 100vw);
    height: calc(64 / 750 * 100vw);
    margin: 0 auto calc(10 / 750 * 100vw);
  }
  .input_list {
    padding: calc(15 / 750 * 100vw) 0 calc(15 / 750 * 100vw);
    width: calc(526 / 750 * 100vw);
    margin: 0 auto;
    li {
      width: 100%;
      height: calc(52 / 750 * 100vw);
      box-sizing: border-box;
      font-family: "font1";
      line-height: calc(52 / 750 * 100vw);
      margin-bottom: calc(30 / 750 * 100vw);
      position: relative;
      input {
        font-family: "font1";
        float: left;
        padding: 0 calc(22 / 750 * 100vw);
        box-sizing: border-box;
        border: none;
        outline: none;
        background: none;
        font-size: calc(20 / 750 * 100vw);
        color: #585858;
        height: calc(52 / 750 * 100vw);
        line-height: calc(52 / 750 * 100vw);
      }
      .input_tips {
        font-size: calc(20 / 750 * 100vw);
        line-height: calc(30 / 750 * 100vw);
        color: #d7c6a1;
        position: absolute;
        left: 0;
        top: 100%;
      }
    }
    .input1 {
      background: url(/img/pc/input1.png) no-repeat;
      background-size: 100% 100%;
      padding-left: calc(70 / 750 * 100vw);
      input {
        width: 100%;
      }
    }
    .input2 {
      background: url(/img/pc/input2.png) no-repeat;
      background-size: 100% 100%;
      input {
        width: calc(392 / 750 * 100vw);
      }
      .btn_code {
        float: right;
        width: calc(128 / 750 * 100vw);
        text-align: center;
        color: #d7c6a1;
        font-size: calc(20 / 750 * 100vw);
      }
    }
  }
  .agree_con {
    display: flex;
    justify-content: center;
    align-items: stretch;
    line-height: calc(20 / 750 * 100vw);
    margin-bottom: calc(3 / 750 * 100vw);
    text-align: center;
    .checkbox {
      width: calc(16 / 750 * 100vw);
      height: calc(16 / 750 * 100vw);
      border: 1px solid #b3b3b3;
      box-sizing: border-box;
      position: relative;
      margin-right: calc(10 / 750 * 100vw);
      cursor: pointer;
      .checkbox_icon {
        background: url(/img/pc/cur.png) no-repeat;
        background-size: 100% 100%;
        width: calc(18 / 750 * 100vw);
        height: calc(16 / 750 * 100vw);
        position: absolute;
        left: 0;
        bottom: calc(1 / 750 * 100vw);
      }
    }
    .agree_box {
      font-size: calc(16 / 750 * 100vw);
      color: #a0a0a0;
      display: flex;
      justify-content: center;
      align-items: stretch;
      line-height: calc(20 / 750 * 100vw);
      a {
        color: #d7c6a1;
      }
    }
  }
  .zc_tips {
    font-size: calc(16 / 750 * 100vw);
    color: #a0a0a0;
    line-height: calc(22 / 750 * 100vw);
    text-align: center;
    padding-bottom: calc(13 / 750 * 100vw);
  }
  .btn_submit {
    background: url(/img/pc/pop_btn.png) no-repeat;
    background-size: 100% 100%;
    width: calc(326 / 750 * 100vw);
    height: calc(54 / 750 * 100vw);
    box-sizing: border-box;
    padding: 0 calc(45 / 750 * 100vw);
    display: block;
    margin: 0 auto;
    line-height: calc(54 / 750 * 100vw);
    text-align: center;
    color: #d7c6a1;
    transition: all 0.2s;
    font-size: calc(24 / 750 * 100vw);
  }
  .btn_submit:active {
    color: #b6a47c;
  }

  @keyframes showPop {
    0% {
      transform: translateY(calc(-10 / 750 * 100vw));
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}

.agree_con.nochecked {
  animation: shake 0.6s ease both;
}
@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: scale(1.03);
  }
  20%,
  40%,
  60%,
  80% {
    transform: scale(1);
  }
}
</style>
